<template>
    <div
        class="flex items-center justify-between text-sm h-10 px-2 lg:px-6 z-30"
        :class="[
            $store.getters.scope === 'preorder' ? 'bg-yellow-400' : 'bg-black',
        ]"
    >
        <div class="space-x-4">
            <button
                v-if="scopes.current"
                type="button"
                class="inline-flex items-center h-10"
                :class="[
                    $store.getters.scope === 'current'
                        ? 'border-b-[3px] text-zinc-50 border-white'
                        : 'text-zinc-500',
                ]"
                @click="setScope('current', true)"
            >
                {{ __("STOCK") }}
            </button>

            <button
                v-if="scopes.preorder"
                type="button"
                class="inline-flex items-center h-10"
                :class="[
                    $store.getters.scope === 'preorder'
                        ? 'border-b-[3px] text-zinc-50 border-white'
                        : 'text-zinc-500',
                ]"
                @click="setScope('preorder', true)"
            >
                {{ __("PREORDER") }}
            </button>

            <button
                v-if="scopes.scoping"
                type="button"
                class="inline-flex items-center h-10"
                :class="[
                    $store.getters.scope === 'scoping'
                        ? 'border-b-[3px] text-zinc-50 border-white'
                        : 'text-zinc-500',
                ]"
                @click="setScope('scoping', true)"
            >
                {{ __("SCOPING") }}
            </button>
        </div>

        <div class="space-x-2">
            <section-header-locale />

            <div class="relative inline-flex">
                <Menu>
                    <MenuButton
                        class="inline-flex items-center p-2"
                        :class="[
                            $store.getters.scope === 'preorder'
                                ? 'text-zinc-800 hover:text-zinc-600'
                                : 'text-zinc-400 hover:text-zinc-500',
                        ]"
                    >
                        <user-icon class="h-4 w-4" />
                        <span class="hidden ml-1 md:inline-flex">{{
                            __("Moje konto")
                        }}</span>
                    </MenuButton>

                    <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95"
                    >
                        <MenuItems
                            class="origin-top-right absolute top-full right-0 w-48 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                        >
                            <div class="p-5 space-y-3">
                                <MenuItem class="block">
                                    <router-link
                                        :to="{
                                            name: 'customer.profile',
                                            params: { lang: $store.getters.lang },
                                        }"
                                        class="w-full text-sm text-left hover:text-zinc-500"
                                    >
                                        {{ __("Profil") }}
                                    </router-link>
                                </MenuItem>

                                <MenuItem class="block">
                                    <button
                                        type="button"
                                        class="w-full text-sm text-left hover:text-zinc-500"
                                        @click="logout"
                                    >
                                        {{ __("Wyloguj") }}
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </transition>
                </Menu>
            </div>

            <button
                type="button"
                @click="toggleHelpModal(true)"
                class="inline-flex items-center p-2"
                :class="[
                    $store.getters.scope === 'preorder'
                        ? 'text-zinc-800 hover:text-zinc-600'
                        : 'text-zinc-400 hover:text-zinc-500',
                ]"
            >
                <question-mark-circle-icon class="h-4 w-4" />
                <span class="hidden ml-1 md:inline-flex">{{ __("Pomoc") }}</span>
            </button>

            <router-link
                :to="{ name: 'order.index', params: { lang: $store.getters.lang } }"
                class="inline-flex items-center p-2"
                :class="[
                    $store.getters.scope === 'preorder'
                        ? 'text-zinc-800 hover:text-zinc-600'
                        : 'text-zinc-400 hover:text-zinc-500',
                ]"
            >
                <clipboard-list-icon class="h-4 w-4" />
                <span class="hidden ml-1 md:inline-flex">{{ __("Zamówienia") }}</span>
            </router-link>
        </div>
    </div>

    <modal :show="modalScope" modal-class="sm:max-w-2xl" @close="closeScopeModal">
        <div class="grid grid-cols-2 gap-4">
            <button
                type="button"
                class="p-4 rounded-md text-left"
                :class="[
                    scopes.current ? 'hover:bg-zinc-50' : 'opacity-40 cursor-not-allowed',
                ]"
                @click="setScope('current', scopes.current)"
            >
                <svg
                    class="w-full"
                    viewBox="0 0 250 253"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M118.245 252.391c-30.383 0-60.869-3.619-61.225-3.67a3.852 3.852 0 0 1-3.365-3.824c0-72.237-1.224-115.62-1.835-133.207l-6.882 7.341a3.807 3.807 0 0 1-5.251.305L1.35 87.016a3.847 3.847 0 0 1-.714-5.047l29.619-44.657C43 20.54 51.718 17.022 52.636 16.665L92.5.301a3.783 3.783 0 0 1 3.67.408c12.184 8.717 27.784 8.207 27.937 8.156h1.631c.306 0 15.956.51 28.089-8.156A3.784 3.784 0 0 1 157.499.3l39.967 16.466c.816.306 9.482 3.823 22.125 20.392l29.721 44.861a3.848 3.848 0 0 1-.714 5.047l-38.336 32.32c-1.53 1.326-3.875 1.173-5.251-.305l-6.882-7.341c-.612 17.536-1.835 60.919-1.835 133.156a3.852 3.852 0 0 1-3.365 3.824c-.357.051-34.92 4.18-67.241 3.619h-1.427c-2.04 0-4.028.051-6.016.051Zm-56.943-10.909c9.38 1.019 36.96 3.619 62.857 3.16H125.739c25.948.459 53.477-2.192 62.857-3.16.051-94.668 2.192-138.765 2.192-139.223.051-1.53 1.07-2.855 2.498-3.416a3.904 3.904 0 0 1 4.129.969l10.655 11.317 32.983-27.784-27.681-41.802c-11.114-14.53-18.659-17.69-18.71-17.69l-38.183-15.65c-13.968 8.972-30.179 8.411-30.893 8.411h-1.325c-.561 0-16.772.612-30.74-8.411l-38.082 15.65c-.204.051-7.748 3.212-19.015 17.945L8.844 83.396l32.984 27.784 10.654-11.317c1.071-1.122 2.651-1.479 4.13-.969a3.806 3.806 0 0 1 2.498 3.416c0 .407 2.14 44.504 2.192 139.172Z"
                        fill="#71717A"
                    />
                    <path
                        d="M207.817 120.253a3.829 3.829 0 0 1-2.804-1.224l-13.153-13.968c-.611-.663-1.019-1.529-1.019-2.447-2.141-51.641 10.298-74.633 11.674-77.08a3.936 3.936 0 0 1 2.753-1.886c1.172-.153 2.345.204 3.161.969 3.67 3.415 7.391 7.646 11.113 12.54l29.721 44.862a3.848 3.848 0 0 1-.714 5.047l-38.336 32.32a3.74 3.74 0 0 1-2.396.867Zm-9.38-19.372 9.686 10.298 32.983-27.784-27.682-41.802a98.128 98.128 0 0 0-6.372-7.596c-3.568 8.717-9.992 29.924-8.615 66.884ZM42.134 120.253a3.749 3.749 0 0 1-2.447-.918L1.35 87.015a3.847 3.847 0 0 1-.714-5.047L30.205 37.31c3.874-5.046 7.596-9.278 11.266-12.744a4.107 4.107 0 0 1 3.16-.918c1.173.153 2.142.867 2.754 1.835.56.97 13.917 24.266 11.725 77.131a3.917 3.917 0 0 1-1.02 2.447L44.938 119.03a3.832 3.832 0 0 1-2.804 1.223ZM8.896 83.395l32.983 27.784 9.686-10.298C52.94 63.718 46.518 42.612 43 33.946a118.644 118.644 0 0 0-6.576 7.85l-27.528 41.6ZM125.995 51.431c-.051 0-.051 0 0 0h-1.988c-40.63 0-51.438-34.869-52.559-38.845a3.798 3.798 0 0 1 2.243-4.537L92.502.299c.969-.407 2.09-.356 3.059.052.968.459 1.682 1.274 2.04 2.294.305.917 7.646 22.176 26.559 21.768h1.58c18.964.357 26.356-20.85 26.662-21.768.306-1.02 1.071-1.835 2.039-2.294A3.763 3.763 0 0 1 157.5.3l18.811 7.749c1.785.713 2.753 2.701 2.243 4.537-1.121 4.027-11.929 38.845-52.559 38.845Zm-1.988-7.646h1.988c29.823 0 40.783-20.902 44.148-30.027l-11.98-4.945c-3.416 7.494-12.796 23.247-31.658 23.247H124.313c-19.219.662-28.956-15.6-32.423-23.247L79.86 13.81c3.364 9.074 14.325 29.976 44.147 29.976-.051 0-.051 0 0 0Z"
                        fill="#71717A"
                    />
                    <path
                        d="M123.393 32.11c-24.113 0-32.78-25.949-33.136-27.07A3.774 3.774 0 0 1 91.633.808a3.826 3.826 0 0 1 4.486 0c12.235 8.718 27.784 8.208 27.937 8.157h1.631c.306 0 15.956.51 28.089-8.157a3.826 3.826 0 0 1 4.486 0 3.848 3.848 0 0 1 1.377 4.283c-.357 1.121-9.023 27.528-34.054 27.07h-1.376c-.255-.052-.51-.052-.816-.052Zm-20.544-19.27c4.18 5.811 10.96 11.928 21.258 11.623h1.58c10.247.153 17.18-5.812 21.36-11.573-10.96 4.079-20.952 3.722-21.513 3.722h-1.325c-.408-.051-10.349.306-21.36-3.772Z"
                        fill="#71717A"
                    />
                </svg>
                <span class="text-2xl text-center font-bold block mt-4">{{
                    __("Stock")
                }}</span>
            </button>

            <button
                type="button"
                class="p-4 rounded-md text-left"
                :class="[
                    scopes.preorder
                        ? 'hover:bg-zinc-50'
                        : 'opacity-40 cursor-not-allowed',
                ]"
                @click="setScope('preorder', scopes.preorder)"
            >
                <svg
                    class="w-full"
                    viewBox="0 0 250 253"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="m178.756 249.948-.713-7.59 3.821-.356c2.7-.255 4.993-.459 6.675-.663v-10.595h7.642v14.008a3.85 3.85 0 0 1-3.363 3.821s-3.872.458-10.19 1.07l-3.872.305ZM196.181 220.913l-7.642-.051v-3.82c.051-6.062.051-11.869.102-17.421l.051-3.821 7.642.051-.051 3.82c-.051 5.553-.102 11.36-.102 17.422v3.82Zm.255-34.791-7.642-.102.051-3.821c.051-6.163.153-12.021.255-17.421l.05-3.82 7.643.102-.051 3.82c-.102 5.451-.153 11.207-.255 17.421l-.051 3.821Zm.51-34.843-7.643-.152.102-3.821c.153-6.571.255-12.378.408-17.421l.102-3.821 7.642.204-.102 3.821c-.153 5.094-.255 10.85-.407 17.421l-.102 3.769ZM207.695 120.157a3.831 3.831 0 0 1-2.803-1.223l-6.878-7.335c0 .357 0 .713-.051 1.07l-.153 3.82-7.642-.255.153-3.82c.255-6.877.407-10.188.407-10.188.051-1.528 1.07-2.852 2.497-3.413a3.903 3.903 0 0 1 4.127.968L208 111.09l7.948-6.673 4.943 5.858-10.7 9.016a3.921 3.921 0 0 1-2.496.866ZM237.755 96.012l-4.943-5.859 8.101-6.825-5.859-8.864 6.369-4.228 7.744 11.665a3.843 3.843 0 0 1-.713 5.043l-10.699 9.068ZM227.721 63.41l-15.795-23.84 6.369-4.228 15.795 23.84-6.369 4.227Zm-23.997-32.856-2.905-2.445c-3.821-3.21-6.063-4.177-6.266-4.228-.051 0-.051 0-.102-.051l-14.674-6.062 2.904-7.08 14.674 6.061v.051c2.547.917 6.267 3.719 8.356 5.502l2.904 2.445-4.891 5.807ZM144.877 13.694l-2.854-7.08 3.516-1.427c3.006-1.223 5.757-2.7 8.152-4.432a3.78 3.78 0 0 1 3.668-.407L170.3 5.696l-2.904 7.08-11.005-4.584a44.867 44.867 0 0 1-7.948 4.075l-3.566 1.427ZM123.374 16.599c-1.121 0-3.465-.052-6.471-.408l-3.821-.458.866-7.59 3.821.458c2.65.306 4.637.357 5.554.357h3.057c.968 0 2.955-.051 5.502-.357l3.822-.458.866 7.59-3.821.458c-2.803.306-5.044.408-6.42.408h-2.955ZM104.932 13.694l-3.567-1.427a52.93 52.93 0 0 1-7.948-4.075l-11.056 4.534-2.904-7.08L92.398.295a3.781 3.781 0 0 1 3.669.408c2.445 1.732 5.145 3.21 8.151 4.432l3.516 1.426-2.802 7.132ZM22.087 63.41l-6.368-4.228 15.794-23.84 6.369 4.228-15.795 23.84Zm23.998-32.856-4.892-5.858 2.905-2.445c4.993-4.177 8.152-5.4 8.457-5.553l14.572-6.01 2.904 7.08-14.725 6.062c-.101.05-2.394.968-6.317 4.279l-2.904 2.445ZM12.05 96.011l-10.7-9.016a3.844 3.844 0 0 1-.713-5.043L8.38 70.287l6.369 4.228-5.86 8.864 8.101 6.825-4.942 5.807ZM42.11 120.155a3.75 3.75 0 0 1-2.446-.917l-10.7-9.016 4.943-5.858 7.948 6.673 10.649-11.309c1.07-1.12 2.649-1.477 4.126-.967a3.803 3.803 0 0 1 2.497 3.413s.153 3.362.408 10.187l.152 3.821-7.642.254-.153-3.82c0-.357 0-.713-.05-1.07l-6.879 7.336c-.815.866-1.834 1.273-2.853 1.273ZM53.575 220.913l-.153-25.062 7.642-.051.153 25.062-7.642.051Zm-.255-34.842-.051-3.821c-.051-6.163-.153-11.97-.204-17.421l-.05-3.82 7.642-.102.05 3.82c.102 5.451.154 11.258.204 17.421l.051 3.821-7.642.102Zm-.459-34.792-.101-3.82c-.153-6.52-.255-12.327-.408-17.37l-.102-3.821 7.642-.204.102 3.821c.153 5.094.255 10.901.408 17.421l.05 3.821-7.59.152ZM70.999 249.95l-3.821-.356c-6.37-.612-10.19-1.07-10.19-1.07a3.849 3.849 0 0 1-3.363-3.82v-14.009h7.642v10.596c1.682.203 3.923.407 6.675.662l3.821.356-.764 7.641ZM132.543 252.191l-.102-7.641 3.821-.051a525.206 525.206 0 0 0 22.775-.815l3.821-.204.459 7.641-3.822.204a541.04 541.04 0 0 1-23.131.815l-3.821.051Zm-15.387 0-3.821-.051a538.16 538.16 0 0 1-23.131-.815l-3.821-.204.458-7.641 3.822.204c7.897.459 15.539.713 22.774.815l3.821.051-.102 7.641Z"
                        fill="#71717A"
                    />
                    <path
                        d="m204.129 41.608-7.234-2.445 1.222-3.617c1.987-5.807 3.669-9.016 4.229-9.933.153-.305.357-.56.612-.815 1.426-1.477 3.821-1.579 5.349-.153 2.395 2.242 4.84 4.84 7.286 7.743l2.446 2.904-5.86 4.94-2.445-2.903c-.968-1.171-1.936-2.241-2.904-3.31a55.272 55.272 0 0 0-1.478 4.023l-1.223 3.566ZM223.281 42.873l-6.371 4.22 13.284 20.043 6.371-4.22-13.284-20.043ZM237.755 96.011l-4.943-5.858 8.101-6.825-5.859-8.864 6.369-4.228 7.744 11.665a3.843 3.843 0 0 1-.713 5.043l-10.699 9.067ZM207.693 120.157a3.826 3.826 0 0 1-2.802-1.222l-9.629-10.188 5.553-5.247 7.133 7.59 7.948-6.673 4.942 5.858-10.699 9.016a3.982 3.982 0 0 1-2.446.866ZM198.064 90.152l-7.642-.153.051-3.82c.153-8.966.815-17.523 1.936-25.47l.509-3.77 7.592 1.07-.51 3.77c-1.07 7.64-1.681 15.944-1.834 24.552l-.102 3.82ZM45.675 41.61l-1.274-3.617a65.788 65.788 0 0 0-1.477-4.024c-.968 1.07-1.936 2.14-2.904 3.311l-2.497 2.904-5.808-4.89 2.445-2.904c2.446-2.853 4.892-5.45 7.286-7.743a3.862 3.862 0 0 1 3.16-1.019 3.773 3.773 0 0 1 2.75 1.834c.357.56 2.14 3.82 4.28 10.035l1.223 3.617-7.184 2.496ZM26.5 42.946 13.214 62.988l6.37 4.221L32.87 47.167l-6.37-4.221ZM12.05 96.013l-10.7-9.016a3.844 3.844 0 0 1-.713-5.043L8.38 70.29l6.369 4.228-5.86 8.863 8.101 6.826-4.942 5.807ZM42.11 120.157a3.745 3.745 0 0 1-2.446-.917l-10.7-9.016 4.943-5.858 7.948 6.673 7.133-7.59 5.553 5.247-9.578 10.188c-.815.866-1.834 1.273-2.853 1.273ZM51.738 90.154l-.05-3.82c-.153-8.66-.765-16.913-1.835-24.553l-.51-3.77 7.592-1.07.51 3.77c1.12 7.946 1.732 16.504 1.936 25.47l.05 3.82-7.693.153ZM77.264 26.176l-1.783-3.413c-2.496-4.737-3.72-8.71-4.127-10.188a3.795 3.795 0 0 1 2.242-4.533l18.8-7.743c.968-.408 2.09-.357 3.057.05a3.937 3.937 0 0 1 2.038 2.293c0 .051 1.274 3.82 4.076 8.252l2.038 3.21-6.42 4.126-2.037-3.21c-1.478-2.292-2.548-4.431-3.363-6.163l-11.973 4.94a46.146 46.146 0 0 0 2.445 5.451l1.784 3.413-6.777 3.515ZM123.476 32.085c-3.617 0-7.133-.612-10.394-1.783l-3.617-1.325 2.598-7.182 3.618 1.324a23.41 23.41 0 0 0 7.795 1.325h2.904c2.7 0 5.299-.459 7.744-1.325l3.618-1.273 2.598 7.182-3.617 1.274a30.657 30.657 0 0 1-10.343 1.783h-2.904ZM172.54 26.174l-6.776-3.514 1.783-3.413a55.095 55.095 0 0 0 2.446-5.45l-11.973-4.89c-.765 1.731-1.886 3.87-3.363 6.163l-2.038 3.209-6.42-4.126 2.038-3.21c2.802-4.38 4.076-8.2 4.076-8.251.306-1.02 1.07-1.834 2.038-2.293a3.761 3.761 0 0 1 3.057-.05l18.8 7.742c1.784.713 2.752 2.7 2.242 4.534-.407 1.477-1.63 5.4-4.127 10.188l-1.783 3.361ZM116.9 51.188l-3.77-.662c-8.305-1.426-15.743-4.534-22.163-9.322l-3.057-2.292 4.586-6.113 3.057 2.292c5.4 4.025 11.769 6.673 18.851 7.896l3.77.662-1.274 7.54Zm16.1-.05-1.324-7.54 3.77-.662c7.082-1.222 13.451-3.922 18.851-7.947l3.057-2.292 4.586 6.113-3.057 2.292c-6.369 4.789-13.858 7.947-22.112 9.373l-3.771.662Z"
                        fill="#71717A"
                    />
                    <path
                        d="m152.617 18.278-6.471-4.126.816-1.273-2.089.866-2.853-7.081 3.515-1.426c3.006-1.223 5.706-2.7 8.152-4.432a3.825 3.825 0 0 1 4.484 0 3.846 3.846 0 0 1 1.375 4.279c-.051.204-1.528 4.737-4.891 9.984l-2.038 3.21ZM126.38 32.083h-2.904a30.44 30.44 0 0 1-10.343-1.783l-3.617-1.274 2.598-7.182 3.617 1.273a23.12 23.12 0 0 0 7.745 1.325h2.904c2.7 0 5.35-.459 7.795-1.325l3.567-1.324 2.598 7.182-3.617 1.325a30.444 30.444 0 0 1-10.343 1.783ZM97.186 18.278l-2.038-3.21c-3.363-5.246-4.84-9.78-4.891-9.983-.51-1.58.05-3.26 1.375-4.279 1.325-.968 3.108-.968 4.484 0 2.445 1.732 5.146 3.21 8.152 4.432l3.515 1.426-2.853 7.03-2.089-.866.815 1.273-6.47 4.177ZM126.431 16.599h-3.057c-1.376 0-3.567-.052-6.42-.408l-3.821-.458.866-7.59 3.821.458c2.599.306 4.586.357 5.554.357H126.38c.968 0 2.955-.051 5.553-.357l3.821-.458.867 7.59-3.822.458a53.638 53.638 0 0 1-6.368.408Z"
                        fill="#71717A"
                    />
                </svg>
                <span class="text-2xl text-center font-bold block mt-4">{{
                    __("Preorder")
                }}</span>
            </button>
        </div>
    </modal>
</template>

<script>
import {
    ClipboardListIcon,
    UserIcon,
    QuestionMarkCircleIcon,
} from "@heroicons/vue/solid";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import Modal from "@/components/Modal";
import SectionHeaderLocale from "@/components/SectionHeaderLocale";
import store from "@/tools/store";

export default {
    name: "SectionHeader",

    components: {
        Modal,
        SectionHeaderLocale,
        Menu,
        MenuButton,
        MenuItems,
        MenuItem,
        ClipboardListIcon,
        UserIcon,
        QuestionMarkCircleIcon,
    },

    data() {
        return {
            scopes: {},
            modalScope: !this.$store.getters.scope,
        };
    },

    mounted() {
        this.fetchData();
    },

    methods: {
        fetchData() {
            this.$api.get("/scope").then((data) => (this.scopes = data));

            if (this.$store.getters.scope) {
                this.getCurrency();
            }
        },

        setScope(scope, active) {
            if (!active) {
                return;
            }

            this.$store.dispatch("setScope", scope);
            this.$api.setHeader("scope", scope);
            this.getCurrency();
            this.$router.push({
                name: "home",
                params: { lang: this.$store.getters.lang },
            });
            this.$emitter.emit("scopeUpdated");
            this.modalScope = false;
        },

        getCurrency() {
            this.$api
                .get("/currency")
                .then((data) => this.$store.dispatch("setCurrency", data));
        },

        closeScopeModal() {
            if (this.$store.getters.scope) {
                this.show = false;
            }
        },

        toggleHelpModal(state) {
            this.$emitter.emit("toggleHelpModal", state);
        },

        logout() {
            this.$api.post("/auth/logout").then(() => {
                this.$store.dispatch("authLogout");
                // this.$router.replace({name: 'auth.login', params: {lang: store.getters.lang}})
                window.location.href = `/${store.getters.lang}/auth/login`;
            });
        },
    },
};
</script>
